module.exports = __webpack_public_path__ + "28381b02ca4f9baa50434973a4f1c455.png";